export const giveAwayContent = {
  de: {
    emailDialog: {
      // Header
      title: "Gutschein per E-Mail senden",
      sendingStatus: "Sende E-Mail...",
      sendToText: "Senden Sie den Gutschein an",

      // Winner Details Card
      winnerDetailsTitle: "🏆 Gewinner Details",
      fields: {
        name: "Name:",
        email: "E-Mail:",
        giveaway: "Gewinnspiel:",
        prize: "Preis:",
      },

      // Voucher Code
      voucherCodeLabel: "Gutscheincode:",
      copyButton: "📋 Kopieren",
      noVoucherWarning: "⚠️",
      noVoucherText: "Für diesen Preis ist noch kein Gutscheincode hinterlegt.",
      noVoucherNote: "Hinweis:",

      // Copy Messages
      copySuccess: "Gutscheincode kopiert!",
      copyError: "Kopieren fehlgeschlagen. Bitte manuell kopieren: ",

      // Email Template
      emailTemplateLabel: "E-Mail Vorlage",
      charactersCount: "Zeichen",
      emailPlaceholder: "Geben Sie hier Ihre E-Mail-Nachricht ein...",
      emailValidationError: "⚠️ E-Mail-Vorlage darf nicht leer sein",

      // Quick Templates
      quickTemplatesLabel: "Schnellvorlagen",
      standardTemplate: "📝 Standard-Vorlage",
      festiveTemplate: "🎉 Festliche Vorlage",

      // Standard Template Text
      standardTemplateText: (
        name,
        giveawayTitle,
        prizeDescription,
        prizeValue,
        voucherCode
      ) =>
        `Hallo ${name},

herzlichen Glückwunsch! Sie haben beim "${giveawayTitle}" gewonnen!

Ihr Gewinn: ${prizeDescription} (${prizeValue})${
          voucherCode
            ? `
Ihr Gutscheincode: ${voucherCode}`
            : ""
        }

Vielen Dank für Ihre Teilnahme!

Mit freundlichen Grüßen
Ihr Team`,

      // Festive Template Text
      festiveTemplateText: (
        name,
        giveawayTitle,
        prizeDescription,
        prizeValue,
        voucherCode
      ) =>
        `Liebe/r ${name},

🎉 HERZLICHEN GLÜCKWUNSCH! 🎉

Sie haben beim "${giveawayTitle}" den tollen Preis gewonnen:
${prizeDescription} im Wert von ${prizeValue}!
${
  voucherCode
    ? `
🎫 Ihr persönlicher Gutscheincode: ${voucherCode}

Bewahren Sie diesen Code gut auf und lösen Sie ihn zeitnah ein.`
    : ""
}

Vielen Dank für Ihre Teilnahme und viel Freude mit Ihrem Gewinn!

Beste Grüße
Ihr Team`,

      // Preview Section
      previewTitle: "📧 E-Mail Vorschau",
      previewTo: "An:",
      previewSubject: "Betreff:",
      previewSubjectText: "🎉 Herzlichen Glückwunsch - Sie haben gewonnen!",
      previewNoMessage: "Keine Nachricht eingegeben...",

      // Buttons
      cancelButton: "Abbrechen",
      sendButton: "📧 E-Mail senden",
      sendingButton: "Sende...",

      // Info Footer
      infoTip: "💡",
      infoTitle: "Tipp:",
      infoText:
        'Nach dem Versenden wird der Status automatisch auf "Gutschein gesendet" aktualisiert. Der Gewinner wird per E-Mail benachrichtigt und kann den Gutscheincode direkt einlösen.',

      // Default Values
      unknownParticipant: "Unbekannt",
      noEmail: "Keine E-Mail",
      unknownGiveaway: "Unbekanntes Giveaway",
      unknownPrize: "Unbekannter Preis",
      unknownValue: "Unbekannt",
    },
    giveawayCard: {
      // Date formatting
      dateNotAvailable: "Nicht verfügbar",

      // Status labels
      status: {
        upcoming: {
          label: "Bevorstehend",
          icon: "⏳",
        },
        active: {
          label: "Aktiv",
          icon: "🟢",
        },
        ended: {
          label: "Beendet",
          icon: "🔴",
        },
        drawn: {
          label: "Ausgelost",
          icon: "🎉",
        },
      },

      // Time calculations
      timeInfo: {
        startsIn: (days) => `Startet in ${days} Tag${days !== 1 ? "en" : ""}`,
        startsToday: "Startet heute",
        endsIn: (days) => `Endet in ${days} Tag${days !== 1 ? "en" : ""}`,
        endsToday: "Endet heute",
        readyForDraw: "Bereit für Auslosung",
        drawnOn: (date) => `Ausgelost am ${date}`,
      },

      // Details
      prizes: (count) => `${count} Preis${count !== 1 ? "e" : ""}`,
      mainPrize: "Hauptpreis:",
      participants: (count) => `${count} Teilnehmer`,
      drawnAt: "Ausgelost:",

      // Action buttons
      actions: {
        draw: "🎲 Auslosen",
        winners: "🏆 Gewinner",
        edit: "✏️ Bearbeiten",
        stats: "📊",
      },

      // Dropdown menu
      menu: {
        edit: "✏️ Bearbeiten",
        showStats: "📊 Statistiken anzeigen",
        drawWinners: "🎲 Gewinner auslosen",
        showWinners: "🏆 Gewinner anzeigen",
        delete: "🗑️ Löschen",
      },

      // Warnings
      activeWarning: "⚠️ Aktive Gewinnspiele können nicht gelöscht werden",

      // Settings badges
      settings: {
        nameRequired: "👤 Name erforderlich",
        emailRequired: "📧 E-Mail erforderlich",
        multipleEntries: "🔄 Mehrfachteilnahme",
        autoDraw: "🤖 Auto-Auslosung",
      },

      // Error messages
      errors: {
        delete: "Fehler bei Löschen:",
        stats: "Fehler bei Stats laden:",
        draw: "Fehler bei Winner auslosen:",
      },
    },
    giveawayForm: {
      editTitle: "Giveaway bearbeiten",
      createTitle: "Neues Giveaway erstellen",

      // Loading states
      deleting: "Löscht...",
      loadingForms: "Lade Formulare...",
      saving: "Speichert...",
      loading: "Lade...",

      // Buttons
      delete: "🗑️ Löschen",
      close: "Schließen",
      cancel: "Abbrechen",
      update: "💾 Aktualisieren",
      create: "✨ Erstellen",
      addPrize: "+ Preis hinzufügen",
      removePrize: "🗑️ Entfernen",

      // Section Headers
      basicInfo: "📋 Grundlegende Informationen",
      timeframe: "📅 Zeitraum",
      prizes: "🏆 Preise",
      settings: "⚙️ Einstellungen",

      // Form Labels
      title: "Titel",
      titleRequired: "Titel *",
      status: "Status",
      description: "Beschreibung",
      descriptionRequired: "Beschreibung *",
      feedbackForm: "Feedback-Formular",
      feedbackFormRequired: "Feedback-Formular *",
      startDate: "Startdatum",
      startDateRequired: "Startdatum *",
      endDate: "Enddatum",
      endDateRequired: "Enddatum *",
      prizeDescription: "Beschreibung",
      prizeDescriptionRequired: "Beschreibung *",
      prizeValue: "Wert",
      prizeValueRequired: "Wert *",
      voucherCode: "Gutscheincode (optional)",

      // Placeholders
      titlePlaceholder: "z.B. Sommer Gaming Contest",
      descriptionPlaceholder: "Beschreiben Sie Ihr Gewinnspiel...",
      feedbackFormPlaceholder: "Bitte wählen Sie ein Formular aus...",
      prizeDescriptionPlaceholder: "z.B. Gaming Laptop",
      prizeValuePlaceholder: "z.B. 1500€",
      voucherCodePlaceholder: "z.B. GAME2024",

      // Status Options
      statusUpcoming: "⏳ Bevorstehend",
      statusActive: "🟢 Aktiv",
      statusEnded: "🔴 Beendet",
      statusDrawn: "🎉 Ausgelost",

      // Settings/Checkboxes
      requiresName: "Name erforderlich",
      requiresEmail: "E-Mail erforderlich",
      allowMultipleEntries: "Mehrfache Teilnahme erlauben",
      autoDrawEnabled: "Automatische Auslosung",

      // Prize Places
      firstPlace: "1. Platz",
      secondPlace: "2. Platz",
      thirdPlace: "3. Platz",
      place: "Platz", // for dynamic places like "4. Platz"

      // Validation Messages
      validation: {
        titleRequired: "Titel ist erforderlich",
        titleMinLength: "Titel muss mindestens 3 Zeichen lang sein",
        descriptionRequired: "Beschreibung ist erforderlich",
        descriptionMinLength:
          "Beschreibung muss mindestens 10 Zeichen lang sein",
        feedbackFormRequired: "Bitte wählen Sie ein Feedback-Formular aus",
        startDateRequired: "Startdatum ist erforderlich",
        endDateRequired: "Enddatum ist erforderlich",
        endDateAfterStart: "Enddatum muss nach dem Startdatum liegen",
        startDateNotPast: "Startdatum kann nicht in der Vergangenheit liegen",
        minOnePrize: "Mindestens ein Preis muss definiert werden",
        prizeDescriptionRequired: "Beschreibung für {{title}} ist erforderlich",
        prizeValueRequired: "Wert für {{title}} ist erforderlich",
        duplicatePlaces: "Jeder Platz darf nur einmal vergeben werden",
        correctErrors: "Bitte korrigieren Sie die Eingabefehler",
      },

      // Success/Error Messages
      messages: {
        updateSuccess: "Giveaway erfolgreich aktualisiert!",
        createSuccess: "Giveaway erfolgreich erstellt!",
        deleteSuccess: "Giveaway erfolgreich gelöscht!",
        loadFormsError: "Fehler beim Laden der Formulare",
        saveError: "Fehler beim Speichern: {{error}}",
        deleteError: "Fehler beim Löschen: {{error}}",
        serviceError: "Fehler: {{error}}",
      },

      // Info Messages
      info: {
        noFormsAvailable:
          "Keine Feedback-Formulare verfügbar. Erstellen Sie zuerst ein Formular.",
        deleteConfirm:
          "Sind Sie sicher, dass Sie dieses Giveaway löschen möchten?",
      },
    },
    giveawayManager: {
      // Tab labels
      tabs: {
        giveaways: "Giveaways",
        winners: "Gewinner",
      },

      // Buttons
      refresh: "Aktualisieren",
      retryButton: "Erneut versuchen",

      // Loading states
      processing: "Verarbeitung läuft...",

      // Error messages
      errors: {
        loadGiveaways: "Giveaways konnten nicht geladen werden",
        loadGiveawaysShort: "Fehler beim Laden der Gewinnspiele",
        loadWinners: "Winner konnten nicht geladen werden",
        loadWinnersShort: "Fehler beim Laden der Gewinner",
        loadWinnersForGiveaway: "Fehler beim Laden der Winner für Giveaway",
        drawWinners: "Fehler beim Ziehen der Winner:",
        drawWinnersShort: "Fehler beim Auslosen der Gewinner",
        updateWinnerStatus: "Fehler beim Aktualisieren des Winner-Status:",
        updateWinnerStatusShort: "Fehler beim Aktualisieren des Winner-Status",
      },

      // Success messages
      success: {
        winnersDrawn: "Winner erfolgreich ausgelost!",
        winnerStatusUpdated: "Winner-Status erfolgreich aktualisiert!",
      },

      // Console messages
      console: {
        errorLoadGiveaways: "Fehler beim Laden der Giveaways:",
        errorLoadWinners: "Fehler beim Laden der Winner:",
        winners: "Winners: ",
      },
    },
    giveawayTab: {
      title: "Giveaway Verwaltung",
      subtitle: "Verwalten Sie alle Ihre Gewinnspiele an einem Ort",
      bulkModal: {
        activate: {
          title: "Gewinnspiele aktivieren",
          action: "activate",
          confirmText:
            "Sind Sie sicher, dass Sie {{count}} Gewinnspiel(e) aktivieren möchten?",
          okText: "Ja, aktivieren",
          icon: "🟢",
          info: "ℹ️ Die Gewinnspiele werden sofort für Teilnehmer verfügbar.",
        },
        end: {
          title: "Gewinnspiele beenden",
          action: "end",
          confirmText:
            "Sind Sie sicher, dass Sie {{count}} Gewinnspiel(e) beenden möchten?",
          okText: "Ja, beenden",
          icon: "🔴",
          info: "ℹ️ Die Gewinnspiele werden beendet und können dann ausgelost werden.",
        },
        affectedGiveaways: "Betroffene Gewinnspiele:",
        cancelText: "Abbrechen",
      },
      // Actions & Buttons
      refresh: "Aktualisieren",
      createNew: "Neues Giveaway",
      createFirst: "Erstes Gewinnspiel erstellen",
      back: "Zurück",
      next: "Weiter",

      // Status Labels
      statusAll: "Alle",
      statusUpcoming: "Bevorstehend",
      statusActive: "Aktiv",
      statusEnded: "Beendet",
      statusDrawn: "Ausgelost",

      // Status Badges
      badgeLive: "LIVE",
      badgeReady: "Bereit",

      // Filter Buttons Text
      filterAll: "Alle ({{count}})",
      filterUpcoming: "Bevorstehend ({{count}})",
      filterActive: "Aktiv ({{count}})",
      filterEnded: "Beendet ({{count}})",
      filterDrawn: "Ausgelost ({{count}})",

      // Bulk Actions
      bulkActivateAll: "Alle bevorstehenden aktivieren",
      bulkActivateShort: "Aktivieren ({{count}})",
      bulkEndAll: "Alle aktiven beenden",
      bulkEndShort: "Beenden ({{count}})",
      bulkDrawReady: "Bereit für Auslosung",
      bulkDrawShort: "Auslosung ({{count}})",

      // Bulk Action Tooltips
      tooltipActivate: "{{count}} bevorstehende Gewinnspiele aktivieren",
      tooltipEnd: "{{count}} aktive Gewinnspiele beenden",
      tooltipDraw: "{{count}} beendete Gewinnspiele bereit für Auslosung",

      // Loading States
      loadingGiveaways: "Gewinnspiele werden geladen...",
      loadingService: "Service lädt...",
      loadingAction: "Verarbeitung läuft...",

      // Empty States
      noGiveaways: "Keine Gewinnspiele gefunden",
      noGiveawaysFiltered:
        'Keine Gewinnspiele mit dem Status "{{status}}" gefunden.',
      noGiveawaysFirst: "Erstellen Sie Ihr erstes Gewinnspiel um loszulegen.",
      showAllGiveaways: "Alle Gewinnspiele anzeigen",

      // Error States
      serviceError: "Service Fehler:",

      // Pagination
      page: "Seite {{current}} von {{total}} ({{items}} Einträge)",

      // Modal Confirmations - Delete
      deleteModal: {
        title: "Gewinnspiel löschen",
        content:
          "Sind Sie sicher, dass Sie dieses Gewinnspiel löschen möchten?",
        warning: "⚠️ Diese Aktion kann nicht rückgängig gemacht werden!",
        okText: "Ja, löschen",
        cancelText: "Abbrechen",
        unknownGiveaway: "Unbekanntes Gewinnspiel",
      },

      // Modal Confirmations - Draw Winners
      drawModal: {
        title: "Gewinner auslosen",
        content:
          "Sind Sie sicher, dass Sie die Gewinner für dieses Gewinnspiel jetzt auslosen möchten?",
        prizes: "Preise:",
        warning: "⚠️ Diese Aktion kann nicht rückgängig gemacht werden!",
        info: '🎯 Nach der Auslosung wechselt das Gewinnspiel automatisch zum Status "Ausgelost".',
        okText: "Ja, auslosen",
        cancelText: "Abbrechen",
      },

      // Success Messages
      success: {
        giveawayUpdated: "Gewinnspiel erfolgreich aktualisiert!",
        giveawayCreated: "Gewinnspiel erfolgreich erstellt!",
        giveawayDeleted: "Gewinnspiel erfolgreich gelöscht!",
        bulkActivated: "{{count}} Gewinnspiel(e) erfolgreich aktiviert!",
        bulkEnded: "{{count}} Gewinnspiel(e) erfolgreich beendet!",
        bulkActivatedWithErrors:
          "{{successful}} Gewinnspiel(e) erfolgreich aktiviert! ({{failed}} fehlgeschlagen)",
        bulkEndedWithErrors:
          "{{successful}} Gewinnspiel(e) erfolgreich beendet! ({{failed}} fehlgeschlagen)",
      },

      // Error Messages
      error: {
        updateFailed: "Update fehlgeschlagen",
        createFailed: "Erstellung fehlgeschlagen",
        deleteFailed: "Löschung fehlgeschlagen",
        updateError: "Fehler beim Aktualisieren",
        createError: "Fehler beim Erstellen",
        deleteError: "Fehler beim Löschen des Gewinnspiels",
        drawError: "Fehler beim Auslosen der Gewinner",
        statsError: "Fehler beim Laden der Statistiken",
        savingError: "Fehler beim Speichern:",
        deletingError: "Fehler beim Löschen:",
        criticalError: "Kritischer Fehler:",
        serviceNotAvailable: "Service nicht verfügbar",
        bulkUpdateFailed:
          "{{count}} Gewinnspiel(e) konnten nicht {{action}} werden. Siehe Konsole für Details.",
        unknownAction: "Unbekannte Aktion",
      },

      // Warning Messages
      warning: {
        noUpcomingToActivate: "Keine Gewinnspiele zum Aktivieren gefunden",
        noActiveToEnd: "Keine Gewinnspiele zum Beenden gefunden",
        noDrawnWinners:
          "Für dieses Gewinnspiel wurden noch keine Gewinner ausgelost",
      },

      // Info Messages
      info: {
        readyForDraw:
          "{{count}} Gewinnspiel(e) bereit für individuelle Auslosung",
        localUpdate:
          "{{count}} Gewinnspiel(e) lokal {{action}}! (updateContest Service nicht verfügbar)",
      },
    },
    statsModal: {
      // Header
      title: "📊 Giveaway Statistiken",
      unknownGiveaway: "Unbekanntes Giveaway",
      closeButton: "Schließen",
      closeTitle: "Schließen",

      // Loading
      loadingStats: "Statistiken werden geladen...",

      // Overview Cards
      overview: {
        participants: "Teilnehmer",
        uniqueParticipants: "Eindeutige Teilnehmer",
        winners: "Gewinner",
        status: "Status",
      },

      // Status Labels
      status: {
        active: "🟢 Aktiv",
        ended: "🔴 Beendet",
        drawn: "🎉 Ausgelost",
        upcoming: "⏳ Bevorstehend",
      },

      // Detail Sections
      sections: {
        giveawayDetails: "ℹ️ Giveaway Details",
        prizes: "🏆 Preise",
        feedbackForm: "📝 Feedback Formular",
        participationSettings: "⚙️ Teilnahme-Einstellungen",
      },

      // Detail Fields
      details: {
        status: "Status:",
        startDate: "Startdatum:",
        endDate: "Enddatum:",
        drawnAt: "Ausgelost am:",
        multipleEntries: "Mehrfach-Teilnahme:",
        autoDraw: "Auto-Auslosung:",
        nameRequired: "Name erforderlich:",
        emailRequired: "E-Mail erforderlich:",
        canEdit: "Kann bearbeitet werden:",
        canDraw: "Kann ausgelost werden:",
        notSet: "Nicht gesetzt",
        allowed: "✅ Erlaubt",
        notAllowed: "❌ Nicht erlaubt",
        enabled: "✅ Aktiviert",
        disabled: "❌ Deaktiviert",
        yes: "✅ Ja",
        no: "❌ Nein",
      },

      // Prizes
      prizes: {
        place: (place) => `${place}. Platz`,
        noPrizes: "Keine Preise definiert",
      },

      // Feedback Form
      feedbackForm: {
        name: "Name:",
        description: "Beschreibung:",
      },

      // Empty State
      emptyState: {
        title: "Keine Statistiken verfügbar",
        description:
          "Für dieses Giveaway sind noch keine Statistiken verfügbar.",
      },
    },
    winnerCard: {
      // Default values
      unknownName: "Unbekannt",
      noEmail: "Keine E-Mail",
      unknownGiveaway: "Unbekanntes Giveaway",
      unknownPrize: "Unbekannter Preis",
      unknownValue: "Unbekannt",

      // Status labels
      statusLabels: {
        pending: "Ausstehend",
        contacted: "Kontaktiert",
        voucher_sent: "Gutschein gesendet",
        completed: "Abgeschlossen",
      },

      // Details
      details: {
        value: "Wert:",
        place: "Platz:",
        drawn: "Gezogen:",
        feedbackSubmitted: "Feedback eingereicht:",
        voucherCode: "Code:",
        voucherSent: "Gutschein gesendet:",
        contactAttempts: "Kontaktversuche:",
      },

      // Quick status actions
      quickActions: {
        markContacted: "✓ Als kontaktiert markieren",
        markVoucherSent: "✓ Gutschein als gesendet markieren",
        markCompleted: "✓ Als abgeschlossen markieren",
      },

      // Buttons
      buttons: {
        sendVoucher: "📧 Gutschein senden",
        details: "Details",
      },

      // Loading indicator
      loadingIndicator: "⏳",
    },
    winnerDetail: {
      title: "Gewinner Details",
      updatingStatus: "Wird aktualisiert...",
      subtitle: "Detaillierte Informationen und Verwaltung für",

      // Tabs
      tabs: {
        info: "📋 Informationen",
        management: "⚙️ Verwaltung",
        history: "📊 Verlauf",
      },

      // Status Labels
      status: {
        pending: {
          label: "Ausstehend",
          icon: "⏳",
        },
        contacted: {
          label: "Kontaktiert",
          icon: "📧",
        },
        voucher_sent: {
          label: "Gutschein gesendet",
          icon: "🎫",
        },
        completed: {
          label: "Abgeschlossen",
          icon: "✅",
        },
      },

      // Info Tab
      info: {
        personalData: {
          title: "👤 Persönliche Daten",
          name: "Name",
          email: "E-Mail",
        },
        giveawayInfo: {
          title: "🎯 Gewinnspiel Information",
          giveaway: "Gewinnspiel",
          place: "Platz",
          prize: "Preis",
          value: "Wert",
          placeText: ". Platz -",
        },
        voucherInfo: {
          title: "🎫 Gutschein Information",
          voucherCode: "Gutscheincode",
          copyButton: "📋 Kopieren",
          noVoucherWarning: "⚠️ Kein Gutscheincode hinterlegt",
        },
        feedbackInfo: {
          title: "💬 Feedback Information",
          submitted: "Feedback eingereicht",
          feedbackId: "Feedback ID",
        },
        timeline: {
          title: "📅 Zeitverlauf",
          drawnAt: "Gezogen am",
          voucherSentAt: "Gutschein gesendet am",
        },
      },

      // Management Tab
      management: {
        statusManagement: {
          title: "⚙️ Status Verwaltung",
          currentStatus: "Aktueller Status",
          markAsContacted: "📧 Als kontaktiert markieren",
          markAsSent: "🎫 Als versendet markieren",
          markAsCompleted: "✅ Als abgeschlossen markieren",
        },
        contactInfo: {
          title: "📞 Kontakt Information",
          attempts: "Kontaktversuche",
          attemptsText: "Versuche",
        },
        notes: {
          title: "📝 Notizen",
          unsaved: "Ungespeichert",
          placeholder: "Notizen zum Gewinner...",
          saveButton: "💾 Notizen speichern",
        },
        email: {
          title: "📧 E-Mail Versand",
          sendButton: "📧 Gutschein per E-Mail senden",
        },
      },

      // History Tab
      history: {
        title: "📊 Aktivitätsverlauf",
        events: {
          drawn: "Gewinner ausgelost",
          feedbackSubmitted: "Feedback eingereicht",
          voucherSent: "Gutschein versendet",
          contactAttempts: "Kontaktversuche:",
          multipleContact: "Mehrfache Kontaktaufnahme",
        },
      },

      // Footer
      footer: {
        winnerId: "Gewinner-ID:",
        closeButton: "Schließen",
      },

      // Messages
      messages: {
        unknown: "Unbekannt",
        unknownGiveaway: "Unbekanntes Giveaway",
        noEmail: "Keine E-Mail",
        unknownPrize: "Unbekannter Preis",
        copied: "kopiert!",
        copyFailed: "Kopieren fehlgeschlagen. Bitte manuell kopieren:",
      },
    },
    winnerStats: {
      // Stats titles
      stats: {
        total: "Gesamt",
        pending: "Ausstehend",
        contacted: "Kontaktiert",
        voucherSent: "Gutschein gesendet",
        completed: "Abgeschlossen",
      },

      // Icons for each status
      icons: {
        total: "🏆",
        pending: "⏳",
        contacted: "📞",
        voucherSent: "📧",
        completed: "✅",
      },
    },
    winnerTab: {
      // Header
      title: "Gewinner Verwaltung",
      subtitle: "Verwalten Sie alle Gewinner und versenden Sie Gutscheine",

      // Buttons
      refresh: "Aktualisieren",
      sendEmails: "E-Mails senden",
      markAllContacted: "Alle als kontaktiert markieren",
      showAllWinners: "Alle Gewinner anzeigen",

      // Filter buttons
      filterButtons: {
        all: "Alle",
        pending: "Ausstehend",
        contacted: "Kontaktiert",
        voucherSent: "Gutschein gesendet",
        completed: "Abgeschlossen",
      },

      // Filter select options
      filterSelect: {
        showAll: "Alle anzeigen",
        pending: "Ausstehend",
        contacted: "Kontaktiert",
        voucherSent: "Gutschein gesendet",
        completed: "Abgeschlossen",
      },

      // Loading states
      loadingWinners: "Gewinner werden geladen...",
      processing: "Verarbeitung läuft...",

      // Success messages
      success: {
        emailSent: (name) => `E-Mail erfolgreich an ${name} gesendet!`,
        voucherSent: (name) =>
          `E-Mail und Gutschein erfolgreich an ${name} gesendet!`,
        statusUpdated: "Status erfolgreich aktualisiert",
        notesUpdated: "Notizen aktualisiert",
        bulkStatusUpdate: (count, status) =>
          `${count} Gewinner erfolgreich auf "${status}" gesetzt`,
        bulkEmailsSent: (count) =>
          `E-Mails erfolgreich an ${count} Gewinner gesendet`,
      },

      // Warning messages
      warnings: {
        noPendingWinners: "Keine ausstehenden Gewinner gefunden",
        noPendingForEmail:
          "Keine ausstehenden Gewinner für E-Mail-Versendung gefunden",
      },

      // Error messages
      errors: {
        sendEmail: "Fehler beim Senden der E-Mail:",
        sendEmailGeneric: (error) =>
          `Fehler beim Senden der E-Mail: ${error || "Unbekannter Fehler"}`,
        updateStatus: "Fehler beim Aktualisieren des Status:",
        updateStatusGeneric: "Fehler beim Aktualisieren des Status",
        updateNotes: "Fehler beim Aktualisieren der Notizen:",
        updateNotesGeneric: "Fehler beim Aktualisieren der Notizen",
        bulkUpdate: "Fehler beim Bulk-Update:",
        bulkUpdateGeneric: "Fehler beim Bulk-Update der Winner",
        bulkEmail: "Fehler beim Bulk E-Mail Versand:",
        bulkEmailGeneric: "Fehler beim Versenden der E-Mails",
      },

      // Email templates
      emailTemplates: {
        winner: (
          name,
          giveawayTitle,
          prizeTitle,
          prizeDescription,
          prizeValue,
          voucherCode
        ) =>
          `Hallo ${name},

herzlichen Glückwunsch! Sie haben beim "${giveawayTitle}" den ${prizeTitle} gewonnen!

Ihr Gewinn: ${prizeDescription} (${prizeValue})${
            voucherCode
              ? `
Ihr Gutscheincode: ${voucherCode}`
              : ""
          }

Vielen Dank für Ihre Teilnahme!

Mit freundlichen Grüßen
Ihr Team`,

        bulk: (name) => `Hallo ${name},

herzlichen Glückwunsch! Sie haben gewonnen!

Mit freundlichen Grüßen
Ihr Team`,
      },

      // Empty states
      emptyState: {
        noWinners: "Keine Gewinner gefunden",
        noWinnersAll: "Es wurden noch keine Gewinner ausgelost.",
        noWinnersFiltered: (status) =>
          `Keine Gewinner mit dem Status "${status}" gefunden.`,
      },

      // Default values
      unknownName: "Unbekannt",
      unknownGiveaway: "Unbekanntes Giveaway",
      unknownPrize: "Unbekannter Preis",
      unknownValue: "Unbekannt",
    },
    serviceMessages: {},
  },
  en: {
    emailDialog: {
      // Header
      title: "Send Voucher via Email",
      sendingStatus: "Sending email...",
      sendToText: "Send the voucher to",

      // Winner Details Card
      winnerDetailsTitle: "🏆 Winner Details",
      fields: {
        name: "Name:",
        email: "Email:",
        giveaway: "Giveaway:",
        prize: "Prize:",
      },

      // Voucher Code
      voucherCodeLabel: "Voucher Code:",
      copyButton: "📋 Copy",
      noVoucherWarning: "⚠️",
      noVoucherText: "No voucher code has been stored for this prize yet.",
      noVoucherNote: "Note:",

      // Copy Messages
      copySuccess: "Voucher code copied!",
      copyError: "Copy failed. Please copy manually: ",

      // Email Template
      emailTemplateLabel: "Email Template",
      charactersCount: "characters",
      emailPlaceholder: "Enter your email message here...",
      emailValidationError: "⚠️ Email template cannot be empty",

      // Quick Templates
      quickTemplatesLabel: "Quick Templates",
      standardTemplate: "📝 Standard Template",
      festiveTemplate: "🎉 Festive Template",

      // Standard Template Text
      standardTemplateText: (
        name,
        giveawayTitle,
        prizeDescription,
        prizeValue,
        voucherCode
      ) =>
        `Hello ${name},

Congratulations! You have won the "${giveawayTitle}"!

Your prize: ${prizeDescription} (${prizeValue})${
          voucherCode
            ? `
Your voucher code: ${voucherCode}`
            : ""
        }

Thank you for your participation!

Best regards,
Your Team`,

      // Festive Template Text
      festiveTemplateText: (
        name,
        giveawayTitle,
        prizeDescription,
        prizeValue,
        voucherCode
      ) =>
        `Dear ${name},

🎉 CONGRATULATIONS! 🎉

You have won the amazing prize in "${giveawayTitle}":
${prizeDescription} worth ${prizeValue}!
${
  voucherCode
    ? `
🎫 Your personal voucher code: ${voucherCode}

Please keep this code safe and redeem it soon.`
    : ""
}

Thank you for participating and enjoy your prize!

Best regards,
Your Team`,

      // Preview Section
      previewTitle: "📧 Email Preview",
      previewTo: "To:",
      previewSubject: "Subject:",
      previewSubjectText: "🎉 Congratulations - You have won!",
      previewNoMessage: "No message entered...",

      // Buttons
      cancelButton: "Cancel",
      sendButton: "📧 Send Email",
      sendingButton: "Sending...",

      // Info Footer
      infoTip: "💡",
      infoTitle: "Tip:",
      infoText:
        'After sending, the status will automatically be updated to "Voucher sent". The winner will be notified by email and can redeem the voucher code directly.',

      // Default Values
      unknownParticipant: "Unknown",
      noEmail: "No Email",
      unknownGiveaway: "Unknown Giveaway",
      unknownPrize: "Unknown Prize",
      unknownValue: "Unknown",
    },
    giveawayCard: {
      // Date formatting
      dateNotAvailable: "Not available",

      // Status labels
      status: {
        upcoming: {
          label: "Upcoming",
          icon: "⏳",
        },
        active: {
          label: "Active",
          icon: "🟢",
        },
        ended: {
          label: "Ended",
          icon: "🔴",
        },
        drawn: {
          label: "Drawn",
          icon: "🎉",
        },
      },

      // Time calculations
      timeInfo: {
        startsIn: (days) => `Starts in ${days} day${days !== 1 ? "s" : ""}`,
        startsToday: "Starts today",
        endsIn: (days) => `Ends in ${days} day${days !== 1 ? "s" : ""}`,
        endsToday: "Ends today",
        readyForDraw: "Ready for draw",
        drawnOn: (date) => `Drawn on ${date}`,
      },

      // Details
      prizes: (count) => `${count} prize${count !== 1 ? "s" : ""}`,
      mainPrize: "Main prize:",
      participants: (count) => `${count} participant${count !== 1 ? "s" : ""}`,
      drawnAt: "Drawn:",

      // Action buttons
      actions: {
        draw: "🎲 Draw",
        winners: "🏆 Winners",
        edit: "✏️ Edit",
        stats: "📊",
      },

      // Dropdown menu
      menu: {
        edit: "✏️ Edit",
        showStats: "📊 Show Statistics",
        drawWinners: "🎲 Draw Winners",
        showWinners: "🏆 Show Winners",
        delete: "🗑️ Delete",
      },

      // Warnings
      activeWarning: "⚠️ Active giveaways cannot be deleted",

      // Settings badges
      settings: {
        nameRequired: "👤 Name required",
        emailRequired: "📧 Email required",
        multipleEntries: "🔄 Multiple entries",
        autoDraw: "🤖 Auto-draw",
      },

      // Error messages
      errors: {
        delete: "Error deleting:",
        stats: "Error loading stats:",
        draw: "Error drawing winners:",
      },
    },
    giveawayForm: {
      editTitle: "Edit Giveaway",
      createTitle: "Create New Giveaway",

      // Loading states
      deleting: "Deleting...",
      loadingForms: "Loading Forms...",
      saving: "Saving...",
      loading: "Loading...",

      // Buttons
      delete: "🗑️ Delete",
      close: "Close",
      cancel: "Cancel",
      update: "💾 Update",
      create: "✨ Create",
      addPrize: "+ Add Prize",
      removePrize: "🗑️ Remove",

      // Section Headers
      basicInfo: "📋 Basic Information",
      timeframe: "📅 Timeframe",
      prizes: "🏆 Prizes",
      settings: "⚙️ Settings",

      // Form Labels
      title: "Title",
      titleRequired: "Title *",
      status: "Status",
      description: "Description",
      descriptionRequired: "Description *",
      feedbackForm: "Feedback Form",
      feedbackFormRequired: "Feedback Form *",
      startDate: "Start Date",
      startDateRequired: "Start Date *",
      endDate: "End Date",
      endDateRequired: "End Date *",
      prizeDescription: "Description",
      prizeDescriptionRequired: "Description *",
      prizeValue: "Value",
      prizeValueRequired: "Value *",
      voucherCode: "Voucher Code (optional)",

      // Placeholders
      titlePlaceholder: "e.g. Summer Gaming Contest",
      descriptionPlaceholder: "Describe your giveaway...",
      feedbackFormPlaceholder: "Please select a form...",
      prizeDescriptionPlaceholder: "e.g. Gaming Laptop",
      prizeValuePlaceholder: "e.g. $1500",
      voucherCodePlaceholder: "e.g. GAME2024",

      // Status Options
      statusUpcoming: "⏳ Upcoming",
      statusActive: "🟢 Active",
      statusEnded: "🔴 Ended",
      statusDrawn: "🎉 Drawn",

      // Settings/Checkboxes
      requiresName: "Name required",
      requiresEmail: "Email required",
      allowMultipleEntries: "Allow multiple entries",
      autoDrawEnabled: "Auto draw enabled",

      // Prize Places
      firstPlace: "1st Place",
      secondPlace: "2nd Place",
      thirdPlace: "3rd Place",
      place: "Place", // for dynamic places like "4th Place"

      // Validation Messages
      validation: {
        titleRequired: "Title is required",
        titleMinLength: "Title must be at least 3 characters long",
        descriptionRequired: "Description is required",
        descriptionMinLength: "Description must be at least 10 characters long",
        feedbackFormRequired: "Please select a feedback form",
        startDateRequired: "Start date is required",
        endDateRequired: "End date is required",
        endDateAfterStart: "End date must be after start date",
        startDateNotPast: "Start date cannot be in the past",
        minOnePrize: "At least one prize must be defined",
        prizeDescriptionRequired: "Description for {{title}} is required",
        prizeValueRequired: "Value for {{title}} is required",
        duplicatePlaces: "Each place can only be awarded once",
        correctErrors: "Please correct the input errors",
      },

      // Success/Error Messages
      messages: {
        updateSuccess: "Giveaway successfully updated!",
        createSuccess: "Giveaway successfully created!",
        deleteSuccess: "Giveaway successfully deleted!",
        loadFormsError: "Error loading forms",
        saveError: "Error saving: {{error}}",
        deleteError: "Error deleting: {{error}}",
        serviceError: "Error: {{error}}",
      },

      // Info Messages
      info: {
        noFormsAvailable:
          "No feedback forms available. Please create a form first.",
        deleteConfirm: "Are you sure you want to delete this giveaway?",
      },
    },
    giveawayManager: {
      // Tab labels
      tabs: {
        giveaways: "Giveaways",
        winners: "Winners",
      },

      // Buttons
      refresh: "Refresh",
      retryButton: "Try again",

      // Loading states
      processing: "Processing...",

      // Error messages
      errors: {
        loadGiveaways: "Giveaways could not be loaded",
        loadGiveawaysShort: "Error loading giveaways",
        loadWinners: "Winners could not be loaded",
        loadWinnersShort: "Error loading winners",
        loadWinnersForGiveaway: "Error loading winners for giveaway",
        drawWinners: "Error drawing winners:",
        drawWinnersShort: "Error drawing winners",
        updateWinnerStatus: "Error updating winner status:",
        updateWinnerStatusShort: "Error updating winner status",
      },

      // Success messages
      success: {
        winnersDrawn: "Winners drawn successfully!",
        winnerStatusUpdated: "Winner status updated successfully!",
      },

      // Console messages
      console: {
        errorLoadGiveaways: "Error loading giveaways:",
        errorLoadWinners: "Error loading winners:",
        winners: "Winners: ",
      },
    },
    giveawayTab: {
      title: "Giveaway Management",
      subtitle: "Manage all your giveaways in one place",
      bulkModal: {
        activate: {
          title: "Activate Giveaways",
          action: "activate", // ✅ HINZUFÜGEN
          confirmText:
            "Are you sure you want to activate {{count}} giveaway(s)?",
          okText: "Yes, activate",
          icon: "🟢",
          info: "ℹ️ The giveaways will be immediately available to participants.",
        },
        end: {
          title: "End Giveaways",
          action: "end", // ✅ HINZUFÜGEN
          confirmText: "Are you sure you want to end {{count}} giveaway(s)?",
          okText: "Yes, end",
          icon: "🔴",
          info: "ℹ️ The giveaways will be ended and can then be drawn.",
        },
        affectedGiveaways: "Affected giveaways:",
        cancelText: "Cancel",
      },
      // Actions & Buttons
      refresh: "Refresh",
      createNew: "New Giveaway",
      createFirst: "Create First Giveaway",
      back: "Back",
      next: "Next",

      // Status Labels
      statusAll: "All",
      statusUpcoming: "Upcoming",
      statusActive: "Active",
      statusEnded: "Ended",
      statusDrawn: "Drawn",

      // Status Badges
      badgeLive: "LIVE",
      badgeReady: "Ready",

      // Filter Buttons Text
      filterAll: "All ({{count}})",
      filterUpcoming: "Upcoming ({{count}})",
      filterActive: "Active ({{count}})",
      filterEnded: "Ended ({{count}})",
      filterDrawn: "Drawn ({{count}})",

      // Bulk Actions
      bulkActivateAll: "Activate all upcoming",
      bulkActivateShort: "Activate ({{count}})",
      bulkEndAll: "End all active",
      bulkEndShort: "End ({{count}})",
      bulkDrawReady: "Ready for draw",
      bulkDrawShort: "Draw ({{count}})",

      // Bulk Action Tooltips
      tooltipActivate: "Activate {{count}} upcoming giveaways",
      tooltipEnd: "End {{count}} active giveaways",
      tooltipDraw: "{{count}} ended giveaways ready for draw",

      // Loading States
      loadingGiveaways: "Loading giveaways...",
      loadingService: "Service loading...",
      loadingAction: "Processing...",

      // Empty States
      noGiveaways: "No giveaways found",
      noGiveawaysFiltered: 'No giveaways with status "{{status}}" found.',
      noGiveawaysFirst: "Create your first giveaway to get started.",
      showAllGiveaways: "Show all giveaways",

      // Error States
      serviceError: "Service Error:",

      // Pagination
      page: "Page {{current}} of {{total}} ({{items}} entries)",

      // Modal Confirmations - Delete
      deleteModal: {
        title: "Delete Giveaway",
        content: "Are you sure you want to delete this giveaway?",
        warning: "⚠️ This action cannot be undone!",
        okText: "Yes, delete",
        cancelText: "Cancel",
        unknownGiveaway: "Unknown Giveaway",
      },

      // Modal Confirmations - Bulk Actions

      // Modal Confirmations - Draw Winners
      drawModal: {
        title: "Draw Winners",
        content: "Are you sure you want to draw winners for this giveaway now?",
        prizes: "Prizes:",
        warning: "⚠️ This action cannot be undone!",
        info: '🎯 After drawing, the giveaway will automatically switch to "Drawn" status.',
        okText: "Yes, draw",
        cancelText: "Cancel",
      },

      // Success Messages
      success: {
        giveawayUpdated: "Giveaway successfully updated!",
        giveawayCreated: "Giveaway successfully created!",
        giveawayDeleted: "Giveaway successfully deleted!",
        bulkActivated: "{{count}} giveaway(s) successfully activated!",
        bulkEnded: "{{count}} giveaway(s) successfully ended!",
        bulkActivatedWithErrors:
          "{{successful}} giveaway(s) successfully activated! ({{failed}} failed)",
        bulkEndedWithErrors:
          "{{successful}} giveaway(s) successfully ended! ({{failed}} failed)",
      },

      // Error Messages
      error: {
        updateFailed: "Update failed",
        createFailed: "Creation failed",
        deleteFailed: "Deletion failed",
        updateError: "Error updating",
        createError: "Error creating",
        deleteError: "Error deleting giveaway",
        drawError: "Error drawing winners",
        statsError: "Error loading statistics",
        savingError: "Error saving:",
        deletingError: "Error deleting:",
        criticalError: "Critical error:",
        serviceNotAvailable: "Service not available",
        bulkUpdateFailed:
          "{{count}} giveaway(s) could not be {{action}}. See console for details.",
        unknownAction: "Unknown action",
      },

      // Warning Messages
      warning: {
        noUpcomingToActivate: "No giveaways found to activate",
        noActiveToEnd: "No giveaways found to end",
        noDrawnWinners: "No winners have been drawn for this giveaway yet",
      },

      // Info Messages
      info: {
        readyForDraw: "{{count}} giveaway(s) ready for individual draw",
        localUpdate:
          "{{count}} giveaway(s) {{action}} locally! (updateContest service not available)",
      },
    },
    statsModal: {
      // Header
      title: "📊 Giveaway Statistics",
      unknownGiveaway: "Unknown Giveaway",
      closeButton: "Close",
      closeTitle: "Close",

      // Loading
      loadingStats: "Loading statistics...",

      // Overview Cards
      overview: {
        participants: "Participants",
        uniqueParticipants: "Unique Participants",
        winners: "Winners",
        status: "Status",
      },

      // Status Labels
      status: {
        active: "🟢 Active",
        ended: "🔴 Ended",
        drawn: "🎉 Drawn",
        upcoming: "⏳ Upcoming",
      },

      // Detail Sections
      sections: {
        giveawayDetails: "ℹ️ Giveaway Details",
        prizes: "🏆 Prizes",
        feedbackForm: "📝 Feedback Form",
        participationSettings: "⚙️ Participation Settings",
      },

      // Detail Fields
      details: {
        status: "Status:",
        startDate: "Start Date:",
        endDate: "End Date:",
        drawnAt: "Drawn At:",
        multipleEntries: "Multiple Entries:",
        autoDraw: "Auto Draw:",
        nameRequired: "Name Required:",
        emailRequired: "Email Required:",
        canEdit: "Can be Edited:",
        canDraw: "Can be Drawn:",
        notSet: "Not set",
        allowed: "✅ Allowed",
        notAllowed: "❌ Not allowed",
        enabled: "✅ Enabled",
        disabled: "❌ Disabled",
        yes: "✅ Yes",
        no: "❌ No",
      },

      // Prizes
      prizes: {
        place: (place) => {
          const suffix =
            place === 1 ? "st" : place === 2 ? "nd" : place === 3 ? "rd" : "th";
          return `${place}${suffix} Place`;
        },
        noPrizes: "No prizes defined",
      },

      // Feedback Form
      feedbackForm: {
        name: "Name:",
        description: "Description:",
      },

      // Empty State
      emptyState: {
        title: "No Statistics Available",
        description: "No statistics are available for this giveaway yet.",
      },
    },
    winnerCard: {
      // Default values
      unknownName: "Unknown",
      noEmail: "No Email",
      unknownGiveaway: "Unknown Giveaway",
      unknownPrize: "Unknown Prize",
      unknownValue: "Unknown",

      // Status labels
      statusLabels: {
        pending: "Pending",
        contacted: "Contacted",
        voucher_sent: "Voucher Sent",
        completed: "Completed",
      },

      // Details
      details: {
        value: "Value:",
        place: "Place:",
        drawn: "Drawn:",
        feedbackSubmitted: "Feedback submitted:",
        voucherCode: "Code:",
        voucherSent: "Voucher sent:",
        contactAttempts: "Contact attempts:",
      },

      // Quick status actions
      quickActions: {
        markContacted: "✓ Mark as contacted",
        markVoucherSent: "✓ Mark voucher as sent",
        markCompleted: "✓ Mark as completed",
      },

      // Buttons
      buttons: {
        sendVoucher: "📧 Send Voucher",
        details: "Details",
      },

      // Loading indicator
      loadingIndicator: "⏳",
    },
    winnerDetail: {
      title: "Winner Details",
      updatingStatus: "Updating...",
      subtitle: "Detailed information and management for",

      // Tabs
      tabs: {
        info: "📋 Information",
        management: "⚙️ Management",
        history: "📊 History",
      },

      // Status Labels
      status: {
        pending: {
          label: "Pending",
          icon: "⏳",
        },
        contacted: {
          label: "Contacted",
          icon: "📧",
        },
        voucher_sent: {
          label: "Voucher Sent",
          icon: "🎫",
        },
        completed: {
          label: "Completed",
          icon: "✅",
        },
      },

      // Info Tab
      info: {
        personalData: {
          title: "👤 Personal Data",
          name: "Name",
          email: "Email",
        },
        giveawayInfo: {
          title: "🎯 Giveaway Information",
          giveaway: "Giveaway",
          place: "Place",
          prize: "Prize",
          value: "Value",
          placeText: ". Place -",
        },
        voucherInfo: {
          title: "🎫 Voucher Information",
          voucherCode: "Voucher Code",
          copyButton: "📋 Copy",
          noVoucherWarning: "⚠️ No voucher code available",
        },
        feedbackInfo: {
          title: "💬 Feedback Information",
          submitted: "Feedback submitted",
          feedbackId: "Feedback ID",
        },
        timeline: {
          title: "📅 Timeline",
          drawnAt: "Drawn at",
          voucherSentAt: "Voucher sent at",
        },
      },

      // Management Tab
      management: {
        statusManagement: {
          title: "⚙️ Status Management",
          currentStatus: "Current Status",
          markAsContacted: "📧 Mark as contacted",
          markAsSent: "🎫 Mark as sent",
          markAsCompleted: "✅ Mark as completed",
        },
        contactInfo: {
          title: "📞 Contact Information",
          attempts: "Contact attempts",
          attemptsText: "attempts",
        },
        notes: {
          title: "📝 Notes",
          unsaved: "Unsaved",
          placeholder: "Notes about the winner...",
          saveButton: "💾 Save notes",
        },
        email: {
          title: "📧 Email Sending",
          sendButton: "📧 Send voucher via email",
        },
      },

      // History Tab
      history: {
        title: "📊 Activity History",
        events: {
          drawn: "Winner drawn",
          feedbackSubmitted: "Feedback submitted",
          voucherSent: "Voucher sent",
          contactAttempts: "Contact attempts:",
          multipleContact: "Multiple contact attempts",
        },
      },

      // Footer
      footer: {
        winnerId: "Winner ID:",
        closeButton: "Close",
      },

      // Messages
      messages: {
        unknown: "Unknown",
        unknownGiveaway: "Unknown Giveaway",
        noEmail: "No Email",
        unknownPrize: "Unknown Prize",
        copied: "copied!",
        copyFailed: "Copy failed. Please copy manually:",
      },
    },
    winnerStats: {
      // Stats titles
      stats: {
        total: "Total",
        pending: "Pending",
        contacted: "Contacted",
        voucherSent: "Voucher Sent",
        completed: "Completed",
      },

      // Icons for each status
      icons: {
        total: "🏆",
        pending: "⏳",
        contacted: "📞",
        voucherSent: "📧",
        completed: "✅",
      },
    },
    winnerTab: {
      // Header
      title: "Winner Management",
      subtitle: "Manage all winners and send vouchers",

      // Buttons
      refresh: "Refresh",
      sendEmails: "Send Emails",
      markAllContacted: "Mark all as contacted",
      showAllWinners: "Show all winners",

      // Filter buttons
      filterButtons: {
        all: "All",
        pending: "Pending",
        contacted: "Contacted",
        voucherSent: "Voucher Sent",
        completed: "Completed",
      },

      // Filter select options
      filterSelect: {
        showAll: "Show all",
        pending: "Pending",
        contacted: "Contacted",
        voucherSent: "Voucher sent",
        completed: "Completed",
      },

      // Loading states
      loadingWinners: "Loading winners...",
      processing: "Processing...",

      // Success messages
      success: {
        emailSent: (name) => `Email successfully sent to ${name}!`,
        voucherSent: (name) =>
          `Email and voucher successfully sent to ${name}!`,
        statusUpdated: "Status updated successfully",
        notesUpdated: "Notes updated",
        bulkStatusUpdate: (count, status) =>
          `${count} winners successfully set to "${status}"`,
        bulkEmailsSent: (count) =>
          `Emails successfully sent to ${count} winners`,
      },

      // Warning messages
      warnings: {
        noPendingWinners: "No pending winners found",
        noPendingForEmail: "No pending winners found for email sending",
      },

      // Error messages
      errors: {
        sendEmail: "Error sending email:",
        sendEmailGeneric: (error) =>
          `Error sending email: ${error || "Unknown error"}`,
        updateStatus: "Error updating status:",
        updateStatusGeneric: "Error updating status",
        updateNotes: "Error updating notes:",
        updateNotesGeneric: "Error updating notes",
        bulkUpdate: "Error with bulk update:",
        bulkUpdateGeneric: "Error with bulk winner update",
        bulkEmail: "Error with bulk email sending:",
        bulkEmailGeneric: "Error sending emails",
      },

      // Email templates
      emailTemplates: {
        winner: (
          name,
          giveawayTitle,
          prizeTitle,
          prizeDescription,
          prizeValue,
          voucherCode
        ) =>
          `Hello ${name},

Congratulations! You have won the ${prizeTitle} in the "${giveawayTitle}"!

Your prize: ${prizeDescription} (${prizeValue})${
            voucherCode
              ? `
Your voucher code: ${voucherCode}`
              : ""
          }

Thank you for your participation!

Best regards,
Your Team`,

        bulk: (name) => `Hello ${name},

Congratulations! You have won!

Best regards,
Your Team`,
      },

      // Empty states
      emptyState: {
        noWinners: "No winners found",
        noWinnersAll: "No winners have been drawn yet.",
        noWinnersFiltered: (status) =>
          `No winners found with status "${status}".`,
      },

      // Default values
      unknownName: "Unknown",
      unknownGiveaway: "Unknown Giveaway",
      unknownPrize: "Unknown Prize",
      unknownValue: "Unknown",
    },
    serviceMessages: {},
  },
};

// Helper for English ordinal suffixes (1st, 2nd, 3rd, 4th, etc.)
const getOrdinalSuffix = (num) => {
  const j = num % 10;
  const k = num % 100;

  if (j === 1 && k !== 11) return "st";
  if (j === 2 && k !== 12) return "nd";
  if (j === 3 && k !== 13) return "rd";

  return "th";
};

export const getStatusText = (status, language = "de") => {
  const content = giveAwayContent[language].giveawayTab;
  const statusMap = {
    upcoming: content.statusUpcoming,
    active: content.statusActive,
    ended: content.statusEnded,
    drawn: content.statusDrawn,
  };
  return statusMap[status] || status;
};

// Helper function für Bulk Action Texte
export const getBulkActionText = (action, language = "de") => {
  const content = giveAwayContent[language].giveawayTab.bulkModal;

  switch (action) {
    case "activate":
      return {
        title: content.activate.title,
        action: content.activate.action,
        icon: content.activate.icon,
        okText: content.activate.okText,
        info: content.activate.info,
      };
    case "end":
      return {
        title: content.end.title,
        action: content.end.action,
        icon: content.end.icon,
        okText: content.end.okText,
        info: content.end.info,
      };
    default:
      return null;
  }
};

// Bestehende Helper-Funktionen...
export const replaceTemplate = (template, variables) => {
  if (!template || typeof template !== "string") return template;

  return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    return variables[key] !== undefined ? variables[key] : match;
  });
};

export const getPlaceText = (place, language = "de") => {
  const content = giveAwayContent[language].giveAwayForm;

  if (place === 1) return content.firstPlace;
  if (place === 2) return content.secondPlace;
  if (place === 3) return content.thirdPlace;

  // For places > 3, use dynamic generation
  if (language === "de") {
    return `${place}. ${content.place}`;
  } else {
    // English ordinal suffixes
    const suffix = getOrdinalSuffix(place);
    return `${place}${suffix} ${content.place}`;
  }
};
